"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionSection = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var button_1 = require("../../action/button");
var link_1 = require("../../structure/link");
var ActionSection = /** @class */function (_super) {
  __extends(ActionSection, _super);
  function ActionSection() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ActionSection.prototype.render = function () {
    var btnContainerClassName = "min-w-0 flex-1";
    var btnComp = react_1.default.createElement(button_1.Button, {
      className: "w-full",
      text: this.props.buttonText,
      type: "dark",
      onClick: this.props.onClick
    });
    return react_1.default.createElement("div", {
      className: "relative rounded-2xl px-6 py-10 bg-primary-500 mx-auto max-w-md shadow-xl sm:px-12 sm:py-20 sm:max-w-3xl lg:max-w-7xl"
    }, react_1.default.createElement("div", {
      className: "sm:text-center"
    }, react_1.default.createElement("h2", {
      className: "text-2xl font-extrabold text-white tracking-tight sm:text-4xl"
    }, this.props.title)), react_1.default.createElement("div", {
      className: "mt-6 sm:mx-auto sm:max-w-sm sm:flex"
    }, this.props.onClick ? react_1.default.createElement("div", {
      className: btnContainerClassName
    }, btnComp) : react_1.default.createElement(link_1.Link, {
      href: this.props.buttonLink,
      custom: this.props.custom,
      linkType: this.props.linkType,
      className: btnContainerClassName
    }, btnComp)));
  };
  return ActionSection;
}(react_1.Component);
exports.ActionSection = ActionSection;